<template>
  <div class="paginated-shared-signal-query">
    <div class="panel panel-default panel-stretch collapsable-panel">

      <div class="panel-heading" data-target="#paginated-shared-signal-queries" data-toggle="collapse">
        Gedeelde signalen
      </div>

      <div class="collapse in" id="paginated-shared-signal-queries">
        <div class="panel-body no-padding">
          <div class="table-responsive">

            <div class="filters">
              Per pagina
              <a-select :disabled="loading" :value="showPerPage" v-on:change="onPerPageChange">
                <a-select-option v-for="(option, index) in perPageOptions" :key="index" :value="option">
                  {{ option }}
                </a-select-option>
              </a-select>

              <signal-query-filter-component :user-id="userId"
                                             :filter-user="true"
                                             :filter-departments="true"
                                             :filter-run-when="true"
                                             :disable-filters="loading"
                                             @filter-query="getFilteredSharedSignalQueries($event)"/>

            </div>

            <div class="paginator" v-if="showPagination">
              <laravel-pagination :data="currentRequestData" :loading="loading"
                                  :disable="loading"
                                  @pagination-change-page="loadPage"/>
            </div>

            <table v-if="sharedSignalQueries.length > 0 || loading"
                   class="table table-striped table-condensed table-bordered">
              <thead>
              <tr>
                <th class="compact">
                  <order-by :order="direction" :select="orderBy" value="name" @change="onOrderByChange"> Naam</order-by>
                </th>
                <th class="compact text-center">
                  <order-by :order="direction" :select="orderBy" value="run_when" @change="onOrderByChange">
                    Controleren
                  </order-by>
                </th>
                <th class="compact text-center">Soort</th>
                <th class="compact text-center">Gebruikers</th>
                <th class="compact text-center">Afdelingen</th>
                <th class="compact text-center">Signalen</th>
                <th class="compact text-center">Automatisch verwerken</th>
                <th class="compact text-center">Zichtbaar voor klant</th>
                <th class="compact nosort"></th>
              </tr>
              </thead>

              <tbody v-if="loading">
              <tr v-for="i in 3">
                <td v-for="i in 9" style="height: 45px;">
                  <Skeleton class="skeleton" :loading="true"
                            style="width: 100%; display: inline-block; height: 25px; padding: 5px;"></Skeleton>
                </td>
              </tr>
              </tbody>

              <tbody v-else>
              <shared-signal-query-row-component :canDetachUser="canDetachUser(sharedSignalQuery)"
                                                 :display-detach-department-message="displayDetachDepartmentMessage(sharedSignalQuery)"
                                                 :user-id="userId"
                                                 v-for="sharedSignalQuery in sharedSignalQueries"
                                                 :query="sharedSignalQuery"
                                                 :key="'sharedSignalQuery-' + sharedSignalQuery.id"
                                                 :display-visible-for-customer="true"/>
              </tbody>

            </table>

            <div v-else style="margin: 1rem;">Er zijn geen gedeelde signalen gevonden.</div>

            <div class="paginator" v-if="showPagination">
              <laravel-pagination :data="currentRequestData" @pagination-change-page="loadPage"/>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {Skeleton} from 'vue-loading-skeleton';
import sharedSignalQueryApi from '~/api/sharedSignalQuery';
import SignalQueryFilterComponent from './FilterComponent';
import SharedSignalQueryRowComponent from './SharedSignalQueryRowComponent';

export default {
  name: "PaginatedSignalQueryComponent",
  components: {
    SignalQueryFilterComponent,
    SharedSignalQueryRowComponent,
    Skeleton
  },
  props: {
    userId: {
      type: [Number, String],
      required: true
    },
  },
  data() {
    return {
      sharedSignalQueries: [],

      perPageOptions: [5, 10, 15, 30, 50],

      loading: true,
      currentPage: null,
      currentRequestData: null,
      showPerPage: 15,
      orderBy: 'name',
      direction: 'asc',
      filterQuery: {},
    }
  },
  mounted() {
    this.loadPage(1, true);
  },
  computed: {
    showPagination() {
      return this.currentRequestData !== null;
    }
  },
  methods: {
    loadPage(page = 1, forceReload = false) {
      if (page === this.currentPage && forceReload !== true) {
        return;
      }
      this.loading = true;

      sharedSignalQueryApi.paginate(
          this.filterQuery,
          this.orderBy,
          this.direction,
          this.showPerPage,
          page,
          ['user_specific_data'],
      ).then(response => {
        this.currentRequestData = response
        this.sharedSignalQueries = response.data
        this.currentPage = page
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Het is niet gelukt de gedeelde signalen op te halen.',
        })
      }).finally(() => {
        this.loading = false
      })
    },

    onPerPageChange(value) {
      this.showPerPage = value;
      this.$nextTick(() => {
        this.loadPage(1, true)
      })
    },
    onOrderByChange(orderBy, direction) {
      this.orderBy = orderBy;
      this.direction = direction;
      this.loadPage(this.currentPage, true);
    },
    getFilteredSharedSignalQueries(filterQuery) {
      this.filterQuery = filterQuery;
      this.loadPage(this.page, true);
    },

    sharedSignalQueryHasUserSpecificData(query) {
      return typeof query.user_specific_data !== 'undefined' && query.user_specific_data !== null
          && typeof query.user_specific_data.data !== 'undefined' && query.user_specific_data.data !== null;
    },

    canDetachUser(query) {
      return this.sharedSignalQueryHasUserSpecificData(query)
          ? query.user_specific_data.data.is_attached_to_user
          : false;
    },
    displayDetachDepartmentMessage(query) {
      return this.sharedSignalQueryHasUserSpecificData(query)
          ? query.user_specific_data.data.is_attached_to_user_through_user_department
          : false;
    },

    onDeleteSignal(id) {
      this.sharedSignalQueries = this.sharedSignalQueries.filter((query) => {
        return query.id !== id
      });
    }
  }
}
</script>

<style scoped>
.paginator {
  margin-left: 2rem;
}

.filters {
  display: inline-block;
  margin: 1rem;
}
</style>